var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 202.538,
    viewBox: "0 0 235 202.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:#6f9c87;}.b{fill:#ffddd5;}.c{fill:#231f20;}.d{fill:#ff6ca8;}.e{fill:#f0ac3f;}.f{fill:#949494;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.g{fill:#f3ebf0;}.h{fill:#e5c1b3;}.i{fill:#191919;}.j{fill:none;stroke:#191919;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.334px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303.866 -192.944)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.114 192.944)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.882 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.144,260.559c-43.636-1.314-43.625-64.716,0-66.023C534.78,195.85,534.769,259.252,491.144,260.559Zm0-65.495c-42.69.766-42.683,64.207,0,64.965C533.833,259.265,533.827,195.824,491.144,195.064Z",
    transform: "translate(-458.421 -194.536)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.732)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.804,
    height: 3.804
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.804,
    height: 3.804
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.804,
    height: 3.804
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.804,
    height: 3.804
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(482.297 207.789)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M506.186,250.707l-8.792-13.049-9.768,7.118,4.417-10.511L480.5,232.291l10.862-4.324-3.4-7.928,7.9,3.466,3.586-15.866,2.707,16.6,10.892-1.993-7.543,7.371,9.151,5.573-9.824.347Z",
    transform: "translate(-480.497 -207.639)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.614 269.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.408,268.544,378.85,297.19l12.227,11.865,24.645-31.547Z",
    transform: "translate(-378.85 -268.544)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.778 245.984)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M408.672,254.288a11.738,11.738,0,0,1,2.3-2.8c2.1-2,3.987-4.788,6.847-5.669,3.45-.005-3.526,7.85-4.093,9.18,1.311-1.1,11.628-13.034,12.091-8.545.053,2.281-5.325,7.3-6.833,9.618,1.576-1,11.624-11.895,11.847-6.688a14.084,14.084,0,0,1-3.759,4.989c-1.3,1.365-2.318,3.079-3.568,4.51,2.65-2.007,5.038-4.434,7.885-6.152,2.22-1.045,2.318,1.058,1.354,2.454a26.418,26.418,0,0,1-3.362,3.8,59.009,59.009,0,0,0-4.626,4.713c-1.451,1.776-2.171,3.874-3.434,5.756l-5.757,8.578-15.765-2.96Z",
    transform: "translate(-399.8 -245.449)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414.743 260.569)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.534,271.925c2.671-2.355,4.349-5.734,6.384-8.638a4.4,4.4,0,0,0,.994-2.583c-.442-2.364-4.207,1.053-4.875,2.02-2.53,3.7-3.647,3.305-7.182,5.291-1.975.883-7.387,8.029-4.3,9.425C416.3,277.668,422.045,273.164,423.534,271.925Z",
    transform: "translate(-413.625 -259.887)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.621 366.262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M441.419,364.514,408.833,390.1l-8.752-3.9a6.707,6.707,0,0,1,.032-4.837C407.932,376.1,432.306,367.637,441.419,364.514Z",
    transform: "translate(-399.645 -364.514)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.071 383.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.126,386.029l-4.985-2.224,5.018-2.612A6.707,6.707,0,0,0,400.126,386.029Z",
    transform: "translate(-395.141 -381.192)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.667 216.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M375.035,252.363c9.725,1.662,8.432-6.95,6.6-14.546.548-.979,2.793-2.16,1.124-3.191-1.056-.7-2.471-1.118-2.913-2.3a53.292,53.292,0,0,0-2.045-7.04,17.717,17.717,0,0,0-4.35-6.367c-22.61-11.974-38.4,18.619-20.4,27.688Z",
    transform: "translate(-345.245 -216.175)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(375.025 229.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M375.736,230.58c.44,1.578-.929,1.948-1.344.362C373.953,229.364,375.323,228.994,375.736,230.58Z",
    transform: "translate(-374.307 -229.559)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.301 239.119)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M381.635,239.092c-.432-.886-1.851-.22-3.1.172,1.037,1.66,1.912,3.458,3.55,2.238Z",
    transform: "translate(-378.54 -238.654)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.96 225.207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.511,227.941c3.744-3.465-.4-4.3-2.393-.874-.691.689-1.6,3.373.239,2.621A12.064,12.064,0,0,0,374.511,227.941Z",
    transform: "translate(-371.273 -224.882)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.432 239.762)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M380.883,240.566a3.1,3.1,0,0,1-2.138-.848.249.249,0,1,1,.349-.357,2.582,2.582,0,0,0,2.517.6.25.25,0,0,1,.152.476A2.918,2.918,0,0,1,380.883,240.566Z",
    transform: "translate(-378.67 -239.29)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(343.416 217.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M347.645,223.009c-1.637-.2-3.594-.75-4.628-2.092.132-1.269,2.6-.815,3.466-.567-.751-.782-1.312-2.967.027-3.438,1.532-.028,2.86,2.527,3.534,3.731Z",
    transform: "translate(-343.017 -216.913)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.558 264.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M441.378,299.58l-5.2,8.6c-7.22,10.545-16.788,1.115-23.957-3.765-25.391-17.579-20.6-11.118-34.414-39.044,6.921-1.445,13.446-4.086,24.177,6.009C411.677,278.322,431.784,292.713,441.378,299.58Z",
    transform: "translate(-377.805 -263.95)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.978 256.524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M421.776,293.57l26-37.688,8.75,10.212L440.93,299.662Z",
    transform: "translate(-421.776 -255.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M26.3,74.659C18.693,79.039-4.063,72.532.632,51.973L6.085,31.661c8,7.711,27.453,6.758,57.673-2.349l63.313-27.2c19.982-7.156,32.689,4.368,23.411,26.492l.02-.011c-.037.076-.074.153-.112.229q-.185.434-.379.873l-.106.042c-7.7,13.582-33.86,21.9-58.087,30.977-18.727,9.47-37.876,17.323-52.164,17.323C34.483,78.041,29.947,77.012,26.3,74.659Z",
    transform: "translate(321.131 316.941)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.558 264.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M424.131,287.236c-4.124,5.946-14.238,20.533-18.235,26.3l-20.883-14.894L377.8,265.371c6.921-1.445,13.446-4.086,24.177,6.009Z",
    transform: "translate(-377.805 -263.95)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.542 247.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M372.426,266.519l2.526-15.731-19.376-4.33c-.491,9.795-1.757,18.652-6.5,23.308l.164-.017-.038.006c5.269,7.668,16.136,1.711,22.035-2.308l1.053-.11.127-.791.041-.032Z",
    transform: "translate(-349.081 -246.459)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.049 250.457)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M374.85,252.019l-11.408-2.143L373.7,256.89Z",
    transform: "translate(-363.442 -249.877)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.949 232.781)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.165)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M455.966,235.167,479.1,256.256l2.451-2.38L458.379,232.7c-.81-.786-1.781.041-2.389.644A1.219,1.219,0,0,0,455.966,235.167Z",
    transform: "translate(-455.569 -232.379)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.531 21.497)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M481.313,253.659l1.946,3.776-.547.549-3.849-1.945Z",
    transform: "translate(-478.862 -253.659)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.344 25.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M482.637,257.826c.175.093.743.472.663-.01l-.229-.522Z",
    transform: "translate(-482.637 -257.294)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.493 23.287)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.522,258.39c-1.115.292-5.862,3.353-7.01,2.538-3.029-2.01,4.406-4.665,5.607-5.5Z",
    transform: "translate(-465.793 -255.431)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.393)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M479.654,248.224c1.544,1.353-.364,4.11-2.1,2.791-2.621-1.548-5.766-3.02-8.838-2.073.306-.1,1.2.286,1.576.3a12.681,12.681,0,0,1,4.777,1.16c4.25,2.018-.7,4.45-2.915,5.125,2.519.551,3.027,3.2.092,3.546-2.4.23-4.594-.535-6.872-.923-3.165,3.46-5.685,6.142-9.181,8.087-.024-.005-8.667-10.225-8.7-10.2,9.414-10.343,13.09-15.248,18.754-15.065,2.7-.169,5.677-.839,8.069.794C475.8,242.8,482.816,246.2,479.654,248.224Z",
    transform: "translate(-447.486 -240.687)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.641 21.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M472.117,255.717a.244.244,0,0,1-.08-.013l-5.915-1.881a.264.264,0,0,1,.1-.514l5.18.42a.265.265,0,0,1-.043.527l-2.868-.233,3.7,1.178a.264.264,0,0,1-.08.516Z",
    transform: "translate(-465.939 -253.308)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.392 26.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M468.647,259.326a.247.247,0,0,1-.061-.007l-2.691-.631a.264.264,0,0,1,.121-.514l2.69.63a.265.265,0,0,1-.06.522Z",
    transform: "translate(-465.692 -258.166)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.461 14.825)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M478.523,249.732c3.04.974.373-3.221-1.358-2.618C475.763,247.849,477.562,249.438,478.523,249.732Z",
    transform: "translate(-476.65 -247.054)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.049 11.88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M480.13,246.884c-1.171.362-4.065-1.81-2.387-2.745C478.683,244.872,480.057,245.559,480.13,246.884Z",
    transform: "translate(-477.232 -244.139)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.445 19.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M481.584,251.8",
    transform: "translate(-481.584 -251.802)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.17 11.075)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M479.481,248.462a.267.267,0,0,1-.132-.036c-1.725-1-2.958-1.815-3.948-2.471-3.263-2.16-3.764-2.492-10.623-1.691a.264.264,0,1,1-.061-.524c7.05-.823,7.649-.427,10.975,1.775.985.652,2.21,1.463,3.923,2.455a.264.264,0,0,1-.133.493Z",
    transform: "translate(-464.483 -243.342)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.303 214.884)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M367.37,233.96c2.261-1.294-.905-8.91-1.772-10.921,1.482.077,4.662.433,5.722-.668.431-1.037-.9-1.59-1.76-1.578,1.832-.444,4.079-.742,5.52-1.989.409-1.637-1.482-2.7-2.9-3.135-8.2-2.193-19.306-1.094-24.618,6.217-6.053,2.9-6.491,11.382-5.314,17.064,1.935,6.519-3.287,6.979-6.963,10.448-1.135,1.243-1.746,3.184-.876,4.626a3.187,3.187,0,0,1,.781,2.535c.281,3.253,4.29,4.207,6.928,3.074,1.332-.471,2.764-1.236,4.072-.7,1.062.434,1.623,1.578,2.469,2.352,2.918,2.534,6.995.662,10.328.138,4.3-.324,10.4-.137,10.2-5.98.418-1.447,2.365-1.717,3.425-2.787,1.309-1.321.923-3.679-.355-5.031-2.2-2.638-6.621-1.683-8.784-4.167C361.49,240.447,367.776,239.748,367.37,233.96Z",
    transform: "translate(-333.996 -214.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.686 230.354)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.762,237.173c-.164,9.6-14.437,9.594-14.6,0C355.327,227.578,369.6,227.579,369.762,237.173Z",
    transform: "translate(-355.163 -229.977)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.575 232.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M357.282,237.4h0a.249.249,0,0,1-.249-.251,5.157,5.157,0,0,1,5.411-5.311h0a5.157,5.157,0,0,1,5.412,5.311.25.25,0,0,1-.249.251h0a.249.249,0,0,1-.249-.249,4.678,4.678,0,0,0-4.913-4.814h0a4.678,4.678,0,0,0-4.912,4.814A.251.251,0,0,1,357.282,237.4Z",
    transform: "translate(-357.033 -231.842)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.216 265.496)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M334.224,281.65c.88-9.412,6.14-11.274,12.577-11.714.6-.084,24.531-3.421,25.887-3.608,16.112-3.677,27.447-2.662,20.1,23.169,3.01,8.249,3.924,15.548.407,20.841-1.247,1.875-1.329,32.086-1.329,32.086-28.911,12.267-56.824,17.9-64.888,5.447Z",
    transform: "translate(-326.98 -264.764)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.097 347.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M417.21,374.271a.264.264,0,0,1-.143-.486l43.554-28.017a.264.264,0,0,1,.286.444l-43.554,28.017A.264.264,0,0,1,417.21,374.271Z",
    transform: "translate(-416.944 -345.726)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(405.728 365.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M408.78,390.111c-9.747-6.372.049-13.852,7.758-14.932,3.264-.687,6.609-1.1,9.74-2.249,9.193-3.569,18.878-14.908,28.606-5.583.848,1.476.123,3.34-.731,4.812-6.659,12.19-19.669,14.616-32.136,17.054C417.737,389.954,413.019,391.676,408.78,390.111Z",
    transform: "translate(-404.7 -363.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.001 204.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.384)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M401.069,229.988a2.047,2.047,0,0,1-1.864-1.2,1.958,1.958,0,0,1-.036-1.526l5.723-14.539a.264.264,0,0,1,.342-.15l3.268,1.287a.261.261,0,0,1,.145.14.264.264,0,0,1,0,.2l-5.724,14.539A1.989,1.989,0,0,1,401.069,229.988Zm4.218-16.83-5.627,14.292a1.435,1.435,0,0,0,.028,1.117,1.5,1.5,0,0,0,.826.786,1.476,1.476,0,0,0,1.922-.81l5.626-14.292Z",
    transform: "translate(-399.031 -212.551)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M411.4,206.4l-2.272,5.772-3.268-1.287,2.272-5.771C408.8,203.35,412.1,204.542,411.4,206.4Z",
    transform: "translate(-405.859 -204.251)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.964 6.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 2.16,
    height: 5.967,
    transform: "translate(0 2.01) rotate(-68.514)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(446.47 271.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M532.755,315.2l-87.723-8.048,18.242-36.484Zm-86.9-8.5,84.8,7.779-67.161-43.046Z",
    transform: "translate(-445.032 -270.667)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(463.748 270.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 3.314,
    height: 3.314
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(445.223 306.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 3.314,
    height: 3.314
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.481 313.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.314,
    height: 3.314
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.652 269.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M312.564,275.72l16.956-6.543-8.493,15.951-1.874-6.825Z",
    transform: "translate(-312.564 -269.178)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.389 292.459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.162,302.105l-2.058-10.65,8.477,6.67-4.207.382Z",
    transform: "translate(-528.104 -291.455)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.292 321.475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.35,326.122l9.074-5.944-2.956,10.373-1.949-3.748Z",
    transform: "translate(-396.35 -320.179)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.866 280.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M320.806,326.045a.305.305,0,0,1-.042,0c-10.124-1.666-15.148-6.959-14.526-15.309a17.224,17.224,0,0,1,.508-3.582,8.666,8.666,0,0,1-1.71-2.734,17.771,17.771,0,0,1,.705-14.235,24.166,24.166,0,0,1,9.743-10.76.264.264,0,1,1,.262.459c-7.887,4.485-14.036,15.066-10.219,24.34a8.1,8.1,0,0,0,1.391,2.32,9.906,9.906,0,0,1,2.752-4.532,8.692,8.692,0,0,1,6.589-2.064,3.648,3.648,0,0,1,3.079.889,3.858,3.858,0,0,1,1.131,3.17l0,.016a6.646,6.646,0,0,1-5.985,6.052,9.14,9.14,0,0,1-5.5-1.165,9.3,9.3,0,0,1-1.8-1.318,17.072,17.072,0,0,0-.417,3.173c-.757,10.159,7.241,13.632,14.084,14.758a.264.264,0,0,1-.043.524Zm-13.47-19.051a8.907,8.907,0,0,0,7.084,2.555,6.075,6.075,0,0,0,5.523-5.593,3.293,3.293,0,0,0-.965-2.735,3.143,3.143,0,0,0-2.669-.749.252.252,0,0,1-.056,0,8.181,8.181,0,0,0-6.231,1.927A9.525,9.525,0,0,0,307.336,306.993Z",
    transform: "translate(-303.866 -279.387)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.736 232.139)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M364.519,239.866a.249.249,0,0,1-.24-.182l-2.128-7.624a.25.25,0,0,1,.481-.134l2.127,7.624a.25.25,0,0,1-.24.316Z",
    transform: "translate(-362.142 -231.744)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.479 262.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M348.029,271.141l1.578-7.166,25.726-2.461v6.061Z",
    transform: "translate(-348.029 -261.514)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(340.307 385.928)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M347.064,389.917a.262.262,0,0,1-.164-.057l-6.86-5.408a.264.264,0,0,1,.327-.415l6.86,5.408a.264.264,0,0,1-.164.472Z",
    transform: "translate(-339.94 -383.981)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.714 288.279)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M421.779,293.514a.257.257,0,0,1-.15-.047.263.263,0,0,1-.068-.367l3.909-5.668a.264.264,0,1,1,.434.3L422,293.4A.264.264,0,0,1,421.779,293.514Z",
    transform: "translate(-421.515 -287.318)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376.423 291.113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M395.26,305.506a.263.263,0,0,1-.162-.056l-19.3-14.854a.264.264,0,1,1,.322-.418l19.3,14.854a.265.265,0,0,1-.161.474Z",
    transform: "translate(-375.691 -290.123)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ad61ed23109caa9cc2a3fdec4d14ee6b.svg";
export { ForwardRef as ReactComponent };